import script from "./AdminSliders.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSliders.vue?vue&type=script&setup=true&lang=js"

import "./AdminSliders.vue?vue&type=style&index=0&id=d5c4f000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c4f000"]])

export default __exports__